import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { Context as ResponsiveContext } from 'react-responsive';

import { TReduxStore } from '../../../shared/types/redux';
import { Application } from '../../../shared/containers/App';
import { initialDeviceWidth } from '../../../shared/utils/initialDeviceWidth';

interface IDependencies {
  store: TReduxStore;
}

export function renderApplication(dependencies: IDependencies) {
  const config = getConfig();
  const { store } = dependencies;

  const {
    page: { deviceType },
  } = store.getState();

  const projectName = config.getStrict<string>('projectName');

  const rootElement = document.getElementById(projectName as string);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  ReactDOM.hydrate(
    <ResponsiveContext.Provider value={{ width: initialDeviceWidth(deviceType) }}>
      <Application config={config} logger={getLogger()} reduxStore={store} />
    </ResponsiveContext.Provider>,
    rootElement,
  );
}
